/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Topnewreleases2Inputs */

const id_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilis baru teratas`)
};

const ms_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluaran baharu teratas`)
};

const da_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top nye udgivelser`)
};

const de_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top Neuerscheinungen`)
};

const en_us2_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top New Releases`)
};

const es_es2_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevos lanzamientos destacados`)
};

const es_mx2_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevos lanzamientos destacados`)
};

const fil_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pinakabagong Release`)
};

const fr_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleures nouvelles sorties`)
};

const it_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuove uscite migliori`)
};

const hu_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legjobb új megjelenések`)
};

const nl_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top nieuwe releases`)
};

const no_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topp nye utgivelser`)
};

const pl_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepsze nowości`)
};

const pt_br2_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principais novos lançamentos`)
};

const pt_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melhores novos lançamentos`)
};

const ro_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cele mai bune lansări noi`)
};

const fi_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parhaat uudet julkaisut`)
};

const sv_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Topp nya släpp`)
};

const vi_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bản phát hành mới hàng đầu`)
};

const tr_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En İyi Yeni Çıkanlar`)
};

const cs_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejlepší nové vydání`)
};

const bg_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Топ нови издания`)
};

const ru_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лучшие новинки`)
};

const uk_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найкращі новинки`)
};

const ar_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أفضل الإصدارات الجديدة`)
};

const hi_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टॉप नए रिलीज़`)
};

const th_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมใหม่ยอดนิยม`)
};

const ja_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注目の新作`)
};

const zh_cn2_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新发布`)
};

const zh_hant1_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最新發布`)
};

const ko_nav_topnewreleases2 = /** @type {(inputs: Nav_Topnewreleases2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신규 출시 TOP`)
};

/**
* | output |
* | --- |
* | "Top New Releases" |
*
* @param {Nav_Topnewreleases2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_topnewreleases2 = /** @type {((inputs?: Nav_Topnewreleases2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Topnewreleases2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_topnewreleases2(inputs)
	if (locale === "ms") return ms_nav_topnewreleases2(inputs)
	if (locale === "da") return da_nav_topnewreleases2(inputs)
	if (locale === "de") return de_nav_topnewreleases2(inputs)
	if (locale === "en-US") return en_us2_nav_topnewreleases2(inputs)
	if (locale === "es-ES") return es_es2_nav_topnewreleases2(inputs)
	if (locale === "es-MX") return es_mx2_nav_topnewreleases2(inputs)
	if (locale === "fil") return fil_nav_topnewreleases2(inputs)
	if (locale === "fr") return fr_nav_topnewreleases2(inputs)
	if (locale === "it") return it_nav_topnewreleases2(inputs)
	if (locale === "hu") return hu_nav_topnewreleases2(inputs)
	if (locale === "nl") return nl_nav_topnewreleases2(inputs)
	if (locale === "no") return no_nav_topnewreleases2(inputs)
	if (locale === "pl") return pl_nav_topnewreleases2(inputs)
	if (locale === "pt-BR") return pt_br2_nav_topnewreleases2(inputs)
	if (locale === "pt") return pt_nav_topnewreleases2(inputs)
	if (locale === "ro") return ro_nav_topnewreleases2(inputs)
	if (locale === "fi") return fi_nav_topnewreleases2(inputs)
	if (locale === "sv") return sv_nav_topnewreleases2(inputs)
	if (locale === "vi") return vi_nav_topnewreleases2(inputs)
	if (locale === "tr") return tr_nav_topnewreleases2(inputs)
	if (locale === "cs") return cs_nav_topnewreleases2(inputs)
	if (locale === "bg") return bg_nav_topnewreleases2(inputs)
	if (locale === "ru") return ru_nav_topnewreleases2(inputs)
	if (locale === "uk") return uk_nav_topnewreleases2(inputs)
	if (locale === "ar") return ar_nav_topnewreleases2(inputs)
	if (locale === "hi") return hi_nav_topnewreleases2(inputs)
	if (locale === "th") return th_nav_topnewreleases2(inputs)
	if (locale === "ja") return ja_nav_topnewreleases2(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_topnewreleases2(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_topnewreleases2(inputs)
	return ko_nav_topnewreleases2(inputs)
});
export { nav_topnewreleases2 as "nav.topNewReleases" }